import React from "react";
import { formatTextWithLineBreaks } from '../utils/helper';
export const About = (props) => {


  return (
    <div id="about">
      <div className="container">
          <div className="row justify-content-center">
              <div className="col-8">
                  <div className="about-text header-section">
                      <h2>{props.data ? props.data.title : "loading..."}</h2>
                      <p>{props.data ? formatTextWithLineBreaks(props.data.text) : "loading..."}</p>
                      <a href="#" className="button">{props.data ? formatTextWithLineBreaks(props.data.button_text) : "loading..."}</a>
                      <ul>
                          <li>
                              <h3>+15k</h3>
                              <p>Concurrent<br />Users</p>
                          </li>
                          <li>
                              <h3>37</h3>
                              <p>Countries<br/>Reached</p>
                          </li>
                          <li>
                              <h3>+700k</h3>
                              <p>Total<br/>Downloads</p>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>
      </div>
    </div>
  );
};
